import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ language, userRole }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'new-case',
      labelEn: 'New Case',
      labelFr: 'Nouveau Dossier',
      labelAr: 'قضية جديدة',
      icon: 'Plus',
      variant: 'default',
      path: '/case-management',
      roles: ['lawyer', 'administrator']
    },
    {
      id: 'add-client',
      labelEn: 'Add Client',
      labelFr: 'Ajouter Client',
      labelAr: 'إضافة عميل',
      icon: 'UserPlus',
      variant: 'outline',
      path: '/client-management',
      roles: ['lawyer', 'secretary', 'administrator']
    },
    {
      id: 'create-invoice',
      labelEn: 'Create Invoice',
      labelFr: 'Créer Facture',
      labelAr: 'إنشاء فاتورة',
      icon: 'Receipt',
      variant: 'outline',
      path: '/billing-invoice',
      roles: ['lawyer', 'administrator']
    },
    {
      id: 'schedule-appointment',
      labelEn: 'Schedule',
      labelFr: 'Planifier',
      labelAr: 'جدولة',
      icon: 'Calendar',
      variant: 'outline',
      path: '/calendar-scheduling',
      roles: ['lawyer', 'secretary', 'administrator']
    }
  ];

  const getLabel = (action) => {
    if (language === 'fr') return action?.labelFr;
    if (language === 'ar') return action?.labelAr;
    return action?.labelEn;
  };

  const filteredActions = actions?.filter((action) =>
    action?.roles?.includes(userRole)
  );

  const titleLabel = {
    en: 'Quick Actions',
    fr: 'Actions Rapides',
    ar: 'إجراءات سريعة'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <h2 className="text-lg md:text-xl font-semibold text-foreground mb-4">
        {titleLabel?.[language]}
      </h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {filteredActions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            onClick={() => navigate(action?.path)}
            className="justify-start"
          >
            {getLabel(action)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;